export default __webpack_public_path__ + "media/images/backgrounds/bg-12-1920x660-246cd18bee7a23c7cbff88d79346d74e.jpg";